import React from 'react'
import './About.css'

const About = () => {
  return (
    <div className="About">
      <div className="info-box"> 
      <h3>THANK YOU FOR VISITING!</h3>
        <p className="para-1">MidDay is an easy to use weather app, to get the weather details of the location entered by you in real time!</p>
        <p className="para-2">Enter the desired location to get weather details such as temperature, precipitation, wind speed & more.</p>
      </div>
    </div>
  )
}

export default About